import { useParams } from 'react-router-dom';
import FeeFormComponent from './FeeForm';
import React from 'react';

export default function ValidationForms() {
  let { id } = useParams();
  return <FeeFormComponent id={id} />;
}
